<template>
  <swiper :options="swiperOption">
    <swiper-slide class="list1" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step2.group.title') }}</p>
          <ul>
            <li class="desc" v-html="$t('page.registration.guide.step2.group.desc')"></li>
            <li class="desc" v-html="$t('page.registration.guide.step2.group.desc2')"></li>
            <li class="desc" v-html="$t('page.registration.guide.step2.group.desc3')"></li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="list2" :class="$i18n.locale">
      <div class="swiper-content--wrap">
        <figure class="img--wrap"></figure>
        <div class="desc--wrap">
          <p class="title">{{ $t('page.registration.guide.step2.page.title') }}</p>
          <ul>
            <li class="desc">{{ $t('page.registration.guide.step2.page.desc') }}</li>
            <li class="desc">{{ $t('page.registration.guide.step2.page.desc2') }}</li>
          </ul>
        </div>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination" ref="pagination"></div>
    <div class="swiper-button-prev icon icon--prev-white-size20" slot="button-prev"></div>
    <div class="swiper-button-next icon icon--prev-white-size20" slot="button-next"></div>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: [
    'focusContent'
  ],
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  watch: {
    focusContent () {
      if (this.focusContent.currentStep === 1) {
        const contentIndex = this.focusContent.currentContentIndex
        this.$refs.pagination.children[contentIndex].click()
      }
    }
  }
}
</script>
